import { APIClient } from '@/services'
import { PulseStore } from '../store'

export function usePulseAnswers() {
  const answers = PulseStore.use(store => store.answers)
  const page = PulseStore.use(state => state.page)

  const setAnswers = (nextAnswers: APIClient.Pulse.AnswerData[]) => {
    PulseStore.set({ answers: nextAnswers })
  }
  const setPage = (nextPage: number) => {
    PulseStore.set({ page: nextPage })
  }

  const answer = answers[page] ?? { value: null, comment: null }

  const setAnswer = (partial: Partial<APIClient.Pulse.AnswerData>) => {
    const next = [...answers]

    if (!next[page]) {
      next[page] = { value: null, comment: null }
    }

    next[page] = {
      ...next[page],
      ...partial,
      skip: partial.skip ?? false,
    }

    setAnswers(next)
    return next
  }

  const clearAnswers = () => setAnswers([])

  return {
    answers,
    answer,
    page,
    setPage,
    setAnswer,
    clearAnswers,
  }
}
